import React from "react";

const MenuToggleButton = ({ isOpen, toggleMenu, dashboard }) => {
  return (
    <button
      onClick={toggleMenu}
      className={`w-6 h-6 flex flex-col justify-between ${
        dashboard ? "lg:hidden" : "md:hidden"
      } transition-all ease-in-out items-start `}
    >
      <span
        className={`h-0.5 bg-primary transition-all ease-in-out duration-1000 ${
          isOpen ? "rotate-45 translate-y-2.5 w-full" : "w-full"
        }`}
      ></span>
      <span
        className={`h-0.5 bg-primary transition-all ease-in-out duration-1000 ${
          isOpen ? "opacity-0 w-full" : "w-5"
        }`}
      ></span>
      <span
        className={`h-0.5 bg-primary transition-all ease-in-out duration-1000 ${
          isOpen ? "-rotate-45 -translate-y-3 w-full" : "w-full"
        }`}
      ></span>
    </button>
  );
};

export default MenuToggleButton;
